// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__D5YBH","modal":"modal_modal__9ncS0","form":"modal_form__J4JCj","label":"modal_label__6YeN8"};